import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterCard extends Bloc {

	constructor (src, ctx) {

		super("filtercard", src, ctx);
		this.f = (src, ins) => [card => card.id.no === ins[0].id.no, card => card.id.no !== ins[0].id.no, card => card.model.key === ins[0].model.key, model => model.key === ins[0].model.key];
		this.types = [Types.card];
	}
}